import React from "react";
import nflogoSort from "assets/img/NFlogosorttekst.svg";
import nflogoHvit from "assets/img/NFlogohvittekst.svg";
import fflogoSort from "assets/img/FFlogo-hvit.svg";
import fflogoHvit from "assets/img/FFlogo-svart.svg";
import { ReactSVG } from "react-svg";

export const nfLogoSort = (
  <ReactSVG
    src={nflogoSort}
    beforeInjection={(svg) => {
      svg.setAttribute(
        "style",
        "max-width: 150px; max-height: 50px; width: 100%"
      );
    }}
  />
);

export const nfLogoHvit = (
  <ReactSVG
    src={nflogoHvit}
    beforeInjection={(svg) => {
      svg.setAttribute(
        "style",
        "max-width: 150px; max-height: 50px; width: 100%"
      );
    }}
  />
);

export const ffLogoSort = (
  <ReactSVG
    src={fflogoSort}
    beforeInjection={(svg) => {
      svg.setAttribute(
        "style",
        "max-width: 150px; max-height: 50px; width: 100%"
      );
    }}
  />
);

export const ffLogoHvit = (
  <ReactSVG
    src={fflogoHvit}
    beforeInjection={(svg) => {
      svg.setAttribute(
        "style",
        "max-width: 150px; max-height: 50px; width: 100%"
      );
    }}
  />
);
